import { useMemo } from "react";
import { formatTimeRu, toDateInputValue } from "../../../utils/appointmentLabels";
import { sessionColor, sessionLabel } from "./calendarUtils";
import { isWeekendDay } from "./desktopCalendarLayout";
import md from "../common/manageDesktop.module.css";

const WEEKDAYS = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];
const MAX_VISIBLE_EVENTS = 3;

function daySessions(sessions, day) {
  return sessions
    .filter((sess) => sess.start_datetime?.slice(0, 10) === day)
    .sort(
      (a, b) =>
        new Date(a.start_datetime) - new Date(b.start_datetime),
    );
}

export default function DesktopMonthGridView({
  days,
  anchor,
  sessions,
  groups,
  onDayClick,
  onSessionClick,
}) {
  const monthKey = anchor?.slice?.(0, 7);
  const todayStr = toDateInputValue();

  const sessionsByDay = useMemo(() => {
    const map = {};
    for (const day of days) {
      map[day] = daySessions(sessions, day);
    }
    return map;
  }, [days, sessions]);

  return (
    <div className={md.desktopMonthGridWrap}>
      <div className={md.desktopMonthWeekdaysRow}>
        {WEEKDAYS.map((w) => (
          <div key={w} className={md.desktopMonthWeekday}>
            {w}
          </div>
        ))}
      </div>

      <div className={md.desktopMonthGridScroll}>
        <div className={md.desktopMonthGrid}>
          {days.map((day) => {
            const list = sessionsByDay[day] || [];
            const inMonth = day.slice(0, 7) === monthKey;
            const today = day === todayStr;
            const selected = day === anchor;
            const weekend = isWeekendDay(day);
            const visible = list.slice(0, MAX_VISIBLE_EVENTS);
            const extra = list.length - visible.length;
            const dayNum = String(Number(day.slice(8, 10))).padStart(2, "0");

            return (
              <button
                key={day}
                type="button"
                className={[
                  md.desktopMonthCell,
                  !inMonth ? md.desktopMonthCellMuted : "",
                  today ? md.desktopMonthCellToday : "",
                  selected ? md.desktopMonthCellSelected : "",
                  weekend && inMonth ? md.desktopMonthCellWeekend : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
                onClick={() => onDayClick(day)}
              >
                <span className={md.desktopMonthDayNum}>{dayNum}</span>

                <div className={md.desktopMonthEvents}>
                  {visible.map((sess) => {
                    const groupIdx = groups.findIndex(
                      (g) => g.id === sess.group?.id,
                    );
                    const color = sessionColor(sess, groupIdx);
                    return (
                      <button
                        key={sess.id}
                        type="button"
                        className={md.desktopMonthEventRow}
                        onClick={(e) => onSessionClick(e, day, sess)}
                      >
                        <span
                          className={md.desktopMonthEventDot}
                          style={{ background: color }}
                          aria-hidden
                        />
                        <span className={md.desktopMonthEventTitle}>
                          {sessionLabel(sess)}
                        </span>
                        <span className={md.desktopMonthEventTime}>
                          {formatTimeRu(sess.start_datetime)}
                        </span>
                      </button>
                    );
                  })}
                  {extra > 0 ? (
                    <span className={md.desktopMonthMore}>+{extra} ещё</span>
                  ) : null}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
